import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Chrome, Loader2 } from "lucide-react";
import { useAuth, homeForRole } from "@/context/AuthContext";
import { HscLogo } from "@/components/HscLogo";
import { ErrorText } from "@/components/kit";

export default function Login() {
  const { login, register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e?.preventDefault();
    setError(null);
    if (mode === "login" && (!email.trim() || !password.trim())) return setError("Isi email/nomor HP dan password");
    if (mode === "register" && (!name.trim() || !phone.trim() || !password.trim())) return setError("Nama, nomor HP, dan password wajib diisi");
    setLoading(true);
    try {
      const user = mode === "login"
        ? await login(email.trim(), password)
        : await register({ name: name.trim(), phone: phone.trim(), email: email.trim() || undefined, password });
      navigate(homeForRole(user.role), { replace: true });
    } catch (err) {
      setError(err.message || "Terjadi kesalahan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-5 py-10">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8 flex flex-col items-center">
          <HscLogo size="text-4xl" className="items-center text-center" />
        </div>
        <h2 className="font-display text-3xl text-white">Your Journey.</h2>
        <p className="mb-8 font-display text-3xl italic text-[#D1D1D6]">Every Visit Matters.</p>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <div>
              <div className="hsc-label mb-1.5">Nama</div>
              <input data-testid="register-name-input" className="hsc-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nama lengkap" />
            </div>
          )}
          {mode === "register" && (
            <div>
              <div className="hsc-label mb-1.5">Nomor HP (WhatsApp)</div>
              <input data-testid="register-phone-input" className="hsc-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="0812xxxxxxxx" />
            </div>
          )}
          <div>
            <div className="hsc-label mb-1.5">{mode === "login" ? "Email atau Nomor HP" : "Email (opsional)"}</div>
            <input data-testid="login-email-input" className="hsc-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={mode === "login" ? "email atau 0812xxxx" : "you@email.com"} autoCapitalize="none" />
          </div>
          <div>
            <div className="hsc-label mb-1.5">Password</div>
            <input data-testid="login-password-input" type="password" className="hsc-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" />
          </div>

          <ErrorText>{error}</ErrorText>

          <button data-testid="login-submit-button" disabled={loading} type="submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-white to-[#D1D1D6] py-3.5 text-[13px] font-bold uppercase tracking-[0.2em] text-black transition-transform active:scale-[0.98] disabled:opacity-60">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : (mode === "login" ? "Sign In" : "Create Account")}
          </button>
        </form>

        <button data-testid="login-toggle-mode" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(null); }}
          className="mt-5 w-full text-center text-sm text-[#8E8E93]">
          {mode === "login" ? "Baru di HSC? " : "Sudah punya akun? "}
          <span className="font-medium text-[#D1D1D6]">{mode === "login" ? "Buat akun" : "Masuk"}</span>
        </button>

        <button data-testid="google-signin-button" onClick={googleLogin} disabled={loading}
          className="mt-6 flex w-full items-center justify-center gap-3 rounded-full border border-[#2C2C2E] bg-[#0E0E10] py-3.5 text-sm font-semibold text-white transition-colors hover:border-[#6E6E73]">
          <Chrome className="h-[18px] w-[18px]" /> Continue with Google
        </button>
      </div>
    </div>
  );
}
